import { css } from '@emotion/react'
import { HFlow, Icon, Spinner, Text, Theme, useTheme } from 'bold-ui'
import { Fragment } from 'react'

import {
  DignidadeMenstrualStatusAutorizacaoAbsorventeEnum,
  dignidadeMenstrualStatusMessages,
} from './model-dignidadeMenstrual'

interface StatusAutorizacaoAbsorventesProps {
  loading: boolean
  cidadaoPossuiCpf: boolean
  statusAutorizacao: DignidadeMenstrualStatusAutorizacaoAbsorventeEnum
}

export function StatusAutorizacaoAbsorventes(props: Readonly<StatusAutorizacaoAbsorventesProps>) {
  const { loading, cidadaoPossuiCpf, statusAutorizacao } = props

  const theme = useTheme()

  const styles = createStyles(theme)

  if (loading) {
    return (
      <HFlow>
        <Spinner style={styles.spinner} />
        <Text>Verificando se o cidadão atende aos critérios do programa.</Text>
      </HFlow>
    )
  }

  const isAptoPrograma = statusAutorizacao === DignidadeMenstrualStatusAutorizacaoAbsorventeEnum.OK

  return (
    <HFlow alignItems='center' hSpacing={0.5}>
      {isAptoPrograma ? (
        <Fragment>
          <Icon size={1} icon='checkCircleOutline' fill='success' />
          <Text color='success'>O cidadão atende aos critérios do programa.</Text>
        </Fragment>
      ) : (
        <Fragment>
          <Icon size={1} icon='banOutline' fill='danger' />
          <Text color='danger'>{getDangerMessage(cidadaoPossuiCpf, statusAutorizacao)}</Text>
        </Fragment>
      )}
    </HFlow>
  )
}

function getDangerMessage(
  cidadaoPossuiCpf: boolean,
  statusAutorizacao: DignidadeMenstrualStatusAutorizacaoAbsorventeEnum
): string {
  if (!cidadaoPossuiCpf) {
    return 'Cidadão não possui CPF cadastrado.'
  }

  return dignidadeMenstrualStatusMessages[statusAutorizacao] ?? 'Erro inesperado! Tente novamente mais tarde.'
}

const createStyles = (theme: Theme) => ({
  spinner: css`
    color: ${theme.pallete.primary.main};
  `,
})
